import { Component, Input, OnInit } from '@angular/core';

import { Proposition } from './propositions/proposition';
import { PropositionService } from './propositions/proposition.service';

@Component({
  selector: 'app-value-proposition',
  templateUrl: './value-proposition.component.html',
  styleUrls: ['./value-proposition.component.css']
})
export class ValuePropositionComponent implements OnInit {

  @Input() onShowPeriod;
  @Input() onEdit;
  
  propositions: Proposition [];
  mockPropositions: Proposition [];
  
  constructor(
    private _propositionService: PropositionService) {}

  getProposition(): void {
    this._propositionService.getProposition().then(propositions => this.propositions = propositions);
  }

  getMockProposition(): void {
    this._propositionService.getMockProposition().then(mockPropositions => this.mockPropositions = mockPropositions);
  }

  ngOnInit(): void {
    this.getProposition();
    this.getMockProposition();
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/value-proposition/value-proposition.component.ts